import { axiosGet } from "../../Helpers";

export const loadSkills = async (setLoading) => {
  setLoading(true);
  const response = await axiosGet("categories/listCategory");
  setLoading(false);
  const data = response.data?.data;
  data.map((item, index) => {
    item.id = index + 1;
  });
  return data;
};
